import React from 'react';

export default function CaseStudyBanner() {
  const caseStats = [
    {
      stat: '40%',
      label: 'Increase in Efficiency',
      icon: (
        <svg className="w-9 h-9 text-[#f25c05]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          {/* Target / Efficiency Icon */}
          <circle cx="12" cy="12" r="9" strokeWidth="1.8" />
          <circle cx="12" cy="12" r="5" strokeWidth="1.8" />
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.8" d="M12 7v10M7 12h10" />
        </svg>
      ),
    },
    {
      stat: '60%',
      label: 'Reduction in Costs',
      icon: (
        <svg className="w-9 h-9 text-[#f25c05]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          {/* Cost Reduction / Shield Chart Icon */}
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.8" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
        </svg>
      ),
    },
    {
      stat: '3X',
      label: 'Faster Time to Market',
      icon: (
        <svg className="w-9 h-9 text-[#f25c05]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          {/* Speed / Network Node Icon */}
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.8" d="M13 10V3L4 14h7v7l9-11h-7z" />
        </svg>
      ),
    },
  ];

  return (
    <section className="relative w-full bg-[#161616] py-12 lg:py-14 font-sans text-white overflow-hidden">
      
      {/* BACKGROUND ABSTRACT ORANGE WAVE GRAPHIC */}
      <div className="absolute right-0 top-0 bottom-0 w-1/2 pointer-events-none opacity-25">
        <svg className="w-full h-full text-[#f25c05]" viewBox="0 0 600 300" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M100 300 C 200 150, 400 350, 600 100" stroke="currentColor" strokeWidth="1.5" />
          <path d="M150 300 C 250 130, 420 330, 600 120" stroke="currentColor" strokeWidth="1.2" />
          <path d="M200 300 C 300 110, 440 310, 600 140" stroke="currentColor" strokeWidth="1" />
          <path d="M250 300 C 350 90, 460 290, 600 160" stroke="currentColor" strokeWidth="0.8" />
          <path d="M300 300 C 400 70, 480 270, 600 180" stroke="currentColor" strokeWidth="0.5" />
        </svg>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-center">
          
          {/* LEFT CONTENT AREA */}
          <div className="lg:col-span-5 space-y-4 text-left">
            {/* Tagline */}
            <p className="text-xs font-bold tracking-widest text-[#f25c05] uppercase">
              CASE STUDY
            </p>

            {/* Title */}
            <h2 className="text-2xl sm:text-3xl font-extrabold text-white leading-tight tracking-tight">
              Transforming Businesses <br className="hidden sm:inline" />
              With AI-Driven Innovation
            </h2>

            {/* Description */}
            <p className="text-gray-400 text-xs sm:text-sm leading-relaxed max-w-sm pt-0.5">
              Discover how we helped our clients automate operations, reduce costs and achieve scalable growth.
            </p>

            {/* CTA Button */}
            <div className="pt-2">
              <a
                href="/case-studies"
                className="inline-flex items-center space-x-2 bg-[#f25c05] hover:bg-[#d95000] text-white font-semibold text-xs px-5 py-2.5 rounded-lg shadow-sm hover:shadow transition-all duration-200 group"
              >
                <span>View Case Study</span>
                <svg className="w-3.5 h-3.5 stroke-current stroke-[2.5] group-hover:translate-x-1 transition-transform" fill="none" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3" />
                </svg>
              </a>
            </div>
          </div>

          {/* RIGHT STATS GRID WITH VERTICAL DIVIDERS */}
          <div className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-3 gap-6 sm:gap-0 items-center pt-6 lg:pt-0">
            {caseStats.map((item, index) => (
              <div
                key={index}
                className={`flex flex-col items-center justify-center text-center px-4 ${
                  index !== caseStats.length - 1
                    ? 'sm:border-r sm:border-gray-800'
                    : ''
                }`}
              >
                {/* SVG Icon */}
                <div className="mb-3">
                  {item.icon}
                </div>

                {/* Big Stat Number */}
                <span className="text-3xl sm:text-4xl font-extrabold text-white tracking-tight leading-none mb-2">
                  {item.stat}
                </span>

                {/* Subtext */}
                <span className="text-xs font-medium text-gray-400 max-w-[120px] leading-tight">
                  {item.label}
                </span>
              </div>
            ))}
          </div>

        </div>
      </div>
    </section>
  );
}